"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('./SoulModule');
/**
 * Email
 * @extends SoulModule
 */


var Email =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Email, _SoulModule);

  function Email() {
    _classCallCheck(this, Email);

    return _possibleConstructorReturn(this, _getPrototypeOf(Email).apply(this, arguments));
  }

  _createClass(Email, [{
    key: "request",

    /**
     * Request Email verification code
     * @param {Object} params
     * @param {string} params.email
     * @param {string} params.captchaToken
     * @param {boolean} params.skipVerification
     * @return {Promise}
     * @soulsdk soul.auth.email.request
     * @example soul.auth.email.request({ email: email@email.com })
     */
    value: function request(_ref) {
      var email = _ref.email,
          captchaToken = _ref.captchaToken,
          skipVerification = _ref.skipVerification,
          ipqsRequestId = _ref.ipqsRequestId;
      this.storage.set('email', email);
      var anonymousUser = this.storage.get('anonymous_user');

      if (this.storage.get('phoneVerification')) {
        this.storage.set('phoneVerification', '');
        this.storage.set('phoneVerificationCode', '');
      }

      return this.api.post('auth/emailcode/request', _objectSpread({
        email: email,
        apiKey: this.apiKey
      }, captchaToken && {
        captchaToken: captchaToken
      }, anonymousUser && {
        anonymous_user: anonymousUser
      }, skipVerification && {
        skipVerification: skipVerification
      }, ipqsRequestId && {
        ipqs_request_id: ipqsRequestId
      }));
    }
    /**
     * Recover session by email and last sessionToken
     * @param {Object} params
     * @param {string} params.email
     * @param {string} [params.lastSessionToken]
     * apply lastSessionToken from storage if not specified
     * @param {function} [callback]
     * @return {Promise}
     * @soulsdk soul.auth.email.recoverSession
     * @example soul.auth.email.recoverSession({ email: email@email.com })
     */

  }, {
    key: "recoverSession",
    value: function recoverSession() {
      var _this = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var email = params.email,
          lastSessionToken = params.lastSessionToken;

      var _this$storage$get = this.storage.get('email'),
          sEmail = _this$storage$get.email;

      var sLastSessionToken = this.storage.get('sessionToken');
      var sEmailVerificationCode = this.storage.get('emailVerificationCode');

      if (!email && !sEmail) {
        return callback(true);
      }

      return this.api.post('auth/emailcode/extend', {
        email: email || sEmail,
        apiKey: this.apiKey,
        code: sEmailVerificationCode,
        lastSessionToken: lastSessionToken || sLastSessionToken
      }, callback).then(function (data) {
        _this.storage.saveSession(data);

        _this.storage.set('isSessionDestroyed', false);

        _this.storage.set('queryQueue', []);

        return data;
      });
    }
    /**
     * Validates user's email and signIn if valid
     * @param {Object} params
     * @param {string} params.code Code received by email
     * @param {string} [params.email] Email will get from localStorage if not defined
     * @param {function} [callback]
     * @return {Promise}
     * @soulsdk soul.auth.email.verify
     * @example soul.auth.email.verify({
     *  code: '12345'
     *  email: email@email.com,
     * })
     */

  }, {
    key: "verify",
    value: function verify(_ref2) {
      var _this2 = this;

      var code = _ref2.code,
          email = _ref2.email,
          ipqsRequestId = _ref2.ipqsRequestId;
      var sEmail = this.storage.get('email');
      return this.api.post('auth/emailcode/verify', _objectSpread({
        code: code,
        email: email || sEmail,
        apiKey: this.apiKey
      }, ipqsRequestId && {
        ipqs_request_id: ipqsRequestId
      })).then(function (data) {
        _this2.storage.saveSession(data);

        _this2.storage.set('emailVerificationCode', code);

        window.localStorage.removeItem('anonymous_user');
        return data;
      });
    }
  }]);

  return Email;
}(SoulModule);

module.exports = Email;